import { toTypedRxJsonSchema } from 'rxdb'

export const CardsSchema = {
  title: 'cards',
  version: 9,
  type: 'object',
  primaryKey: 'id',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    sourceText: {
      type: 'string',
    },
    sourceLanguage: {
      type: 'string',
    },
    learnText: {
      type: 'string',
    },
    learnLanguage: {
      type: 'string',
    },
    pronunciation: {
      type: 'string',
    },
    examples: {
      type: 'string',
    },
    snoozedUntilSource: {
      type: 'number',
    },
    snoozeCountSource: {
      type: 'number',
    },
    snoozedUntilLearn: {
      type: 'number',
    },
    snoozeCountLearn: {
      type: 'number',
    },
    createdAt: {
      type: 'number',
    },
    updatedAt: {
      type: 'number',
    },
    userId: {
      type: 'number',
    },
  },
  required: [
    'id',
    'createdAt',
    'updatedAt',
    'userId',
    'learnLanguage',
    'learnText',
    'sourceLanguage',
    'sourceText',
    'snoozeCountSource',
    'snoozeCountLearn',
  ],
} as const

export const CardsSchemaTyped = toTypedRxJsonSchema(CardsSchema)
